import store from '@/store'
import { getData } from '@core/utils/http/general'
import { ref } from '@vue/composition-api'

//* Method to fill param request from table 'Cursos'
export const configTableCursos = () => {
  //* This will be our table columns => { key: 'name of the object propiety', label: 'how to show in table' }
  const tableColumns = [
    { key: 'id', sortable: true, isRowHeader: true },
    {
      key: 'materia', label: 'Grupo y Materia', sortable: true,
    },
    { key: 'modalidad', sortable: true },
    {
      key: 'num_parciales', label: 'Parciales',
    },
    { key: 'periodo', label: 'Información de periodo', sortable: true },
    { key: 'temporalidad', sortable: true },
  ]
  //* Params to fill table data & filters
  const configRequest = ref({
    nivel: null, //* Filter
    periodo: null, //* Filter
    modalidad: null, //* Filter
    wsParams: { action: 1, token: store.state.cuenta.session.token }, //* Request params
    wsType: 'wscursos', //* WebService name
    filterGetter: 'servicioEscolar/filterCursos', //* Getter function to filter data
  })

  return { tableColumns, configRequest }
}

//* Method to fill param request from table 'Materias'
export const configTableMaterias = () => {
  //* This will be our table columns => { key: 'name of the object propiety', label: 'how to show in table' }
  const tableColumns = [
    { key: 'id', sortable: true, stickyColumn: true },
    { key: 'nombre', sortable: true },
    { key: 'objetivo', sortable: true },
    { key: 'opciones' },
  ]
  //* Params to fill table data & filters
  const configRequest = ref({
    wsParams: { action: 1, token: store.state.cuenta.session.token }, //* Request params
    wsType: 'wsmaterias', //* WebService name
    filterGetter: 'servicioEscolar/filterMaterias', //* Getter function to filter data
  })

  return { tableColumns, configRequest }
}

//* Load filter options with promises
export const useServicioEscolarCatalogos = () => {
  const modalidadOptions = [{ label: 'Presencial', value: 'PR' }, { label: 'Sesión remota', value: 'SR' }, { label: 'En línea', value: 'EL' }]
  const AspiranteStatusOptions = [
    { label: 'Paso 1', value: 'ACT' },
    { label: 'Paso 2', value: 'ST2' },
    { label: 'Paso 3', value: 'ST3' },
    { label: 'Paso 4', value: 'ST4' },
    { label: 'Paso 5', value: 'ST5' },
    { label: 'Cancelado', value: 'CAN' }]
  // ('ACT', 'CAN', 'ST2', 'ST3', 'ST4', 'ST6'
  const periodoOptions = ref([])
  const planOptions = ref([])
  // buscar periodos por token
  const periodoOptionsPromise = () => new Promise((resolve, reject) => {
    getData({ action: 1, token: store.state.cuenta.session.token }, 'wsperiodo')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) resolve(response.data.data)
        else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })
  // buscar planes por token
  const planOptionsPromise = () => new Promise((resolve, reject) => {
    getData({ action: 17, token: store.state.cuenta.session.token }, 'wscompras')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) resolve(response.data.data)
        else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })

  // buscar planes por matricula
  const planxmtrl = matricula => new Promise((resolve, reject) => {
    getData({ action: 45, token: store.state.cuenta.session.token, matricula }, 'wscompras')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) resolve(response.data)
        else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })

  //* SEARCH CURSOS POR PERIODO
  const cursosxperiodo = (periodo, plan, modalidad) => new Promise((resolve, reject) => {
    getData({
      action: 46, token: store.state.cuenta.session.token, periodo, plan, modalidad,
    }, 'wscompras')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) resolve(response.data)
        else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })

  const planselect = (personafk, periodo, planest) => new Promise((resolve, reject) => {
    getData({
      action: 4, token: store.state.cuenta.session.token, personafk, periodo, plan_estudios: planest,
    }, 'wsalumno')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) resolve(response.data)
        else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })

  const ofertaacademica = () => new Promise((resolve, reject) => {
    getData({ action: 7 }, 'wspublico')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) resolve(response.data)
        else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })

  //* GET PERIODOS POR PLAN
  const periodosxplan = (plan, limitado) => new Promise((resolve, reject) => {
    getData({ action: 21, plan, limitado }, 'wspublico')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) resolve(response.data)
        else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })

  // buscar periodos activos
  // buscar planes y periodos por matricula
  const periodosComprados = mtrl => new Promise((resolve, reject) => {
    getData({ action: 28, token: store.state.cuenta.session.token, matricula: mtrl }, 'wscompras')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) resolve(response.data)
        else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })

  return {
    // Promise fetch options
    periodoOptionsPromise,
    planOptionsPromise,
    planxmtrl,
    planselect,
    ofertaacademica,
    periodosComprados,
    cursosxperiodo,
    periodosxplan,

    // Options
    periodoOptions,
    planOptions,
    modalidadOptions,
    AspiranteStatusOptions,
  }
}

//* Method to fill param request from table 'Aspirantes'
export const configTableAspirantes = () => {
  // get rol
  const { id: rol } = store.state.cuenta.rolSelected

  const tableColumns = [
    {
      key: 'id', sortable: true, variant: 'secondary',
    },
    // { key: 'selection', label: '', sortable: false },
    // { key: 'show_details', label: 'Registro' },
    { key: 'opciones' },
    { key: 'docs_pend', label: 'DCP', sortable: true },
    { key: 'persona_fk', label: 'Datos' },
    { key: 'status', label: 'Estado', sortable: true },
    { key: 'fullname', label: 'Nombre' },
    { key: 'time', label: 'Registrado', sortable: true },
    // { key: 'telefono' },
    // { key: 'strEntidadFed', label: 'Entidad Federativa', sortable: true },
    // { key: 'time', label: 'Registrado' },
    // { key: 'strDependencia', label: 'Dependencia' },
    // { key: 'strbeca', label: 'Beca Sugerida' },
  ]
  //* Params to fill table data & filters
  const configRequest = ref({
    status: null, //* Filter
    wsParams: {
      action: 11,
      rol,
      token: store.state.cuenta.session.token,
      plan: null,
      nivel: null,
      periodo: null,
      modalidad: null,
      estado: null,
    },
    wsType: 'wscompras', //* WebService name
    filterGetter: 'servicioEscolar/filterCatAspi', //* Getter function to filter data
  })

  return { tableColumns, configRequest }
}

//* Get dependency's data
export const getDependenciaJSONData = id => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 1,
    id,
    token: store.state.cuenta.session.token,
  }

  getData(paramsRequest, 'wsDependencia')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve(response.data.data)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

//* Search dependency by RFC
export const searchDependency = rfc => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 3,
    rfc,
  }

  getData(paramsRequest)
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve(response.data.data)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
